// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Pagination';



// WEBPACK FOOTER //
// ./components/Pagination/index.js